import * as Types from "@zapier/reporting/src/graphql-types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CurrentAccountPlanFragment = {
  __typename?: "Plan";
  allowImportExport: boolean;
  allowProfessional: boolean;
  hasMeteredBilling: boolean;
  hasTeams: boolean;
  id: string;
  name: string;
  planType: string;
  tasks: number;
  meteredPricingTiers?: Array<{
    __typename?: "MeteredPricingTier";
    limit: number;
    perTask: number;
  }> | null;
};

export type AccountLimitsFragment = {
  __typename?: "Entitlements";
  isAlertsCenterEnabled: boolean;
  isTaskUsageAlertsEnabled: boolean;
  isAnalyticsDashboardEnabled: boolean;
  isCustomNotificationsEnabled: boolean;
  isLogStreamsEnabled: boolean;
  isWorkspacesEnabled: boolean;
  rolloutStage: string;
};

export type AccountAndUserQueryVariables = Types.Exact<{
  accountId: Types.Scalars["ID"]["input"];
}>;

export type AccountAndUserQuery = {
  __typename?: "Query";
  account: {
    __typename?: "Account";
    allowTaskReplay: boolean;
    currentUserRole: Types.MemberRole;
    id: string;
    isPaying: boolean;
    dataRetentionDays: number;
    parentAccountRelationship?: string | null;
    currentBillingCycle: { __typename?: "DateRange"; from: string; to: string };
    currentUsageCycle: { __typename?: "DateRange"; from: string; to: string };
    entitlements: {
      __typename?: "Entitlements";
      isAlertsCenterEnabled: boolean;
      isTaskUsageAlertsEnabled: boolean;
      isAnalyticsDashboardEnabled: boolean;
      isCustomNotificationsEnabled: boolean;
      isLogStreamsEnabled: boolean;
      isWorkspacesEnabled: boolean;
      rolloutStage: string;
    };
    plan: {
      __typename?: "Plan";
      allowImportExport: boolean;
      allowProfessional: boolean;
      hasMeteredBilling: boolean;
      hasTeams: boolean;
      id: string;
      name: string;
      planType: string;
      tasks: number;
      meteredPricingTiers?: Array<{
        __typename?: "MeteredPricingTier";
        limit: number;
        perTask: number;
      }> | null;
    };
    parentAccount?: {
      __typename?: "ParentAccount";
      id: string;
      name: string;
    } | null;
  };
  currentUser?: {
    __typename?: "User";
    email: string;
    fullName: string;
    id: string;
    isStaff: boolean;
  } | null;
};

export const CurrentAccountPlanFragmentDoc = gql`
  fragment CurrentAccountPlan on Plan {
    allowImportExport
    allowProfessional
    hasMeteredBilling
    hasTeams
    id
    meteredPricingTiers {
      limit
      perTask
    }
    name
    planType
    tasks
  }
`;
export const AccountLimitsFragmentDoc = gql`
  fragment AccountLimits on Entitlements {
    isAlertsCenterEnabled
    isTaskUsageAlertsEnabled
    isAnalyticsDashboardEnabled
    isCustomNotificationsEnabled
    isLogStreamsEnabled
    isWorkspacesEnabled
    rolloutStage
  }
`;
export const AccountAndUserDocument = gql`
  query AccountAndUser($accountId: ID!) {
    account(id: $accountId) {
      allowTaskReplay
      currentBillingCycle {
        from
        to
      }
      currentUsageCycle {
        from
        to
      }
      currentUserRole
      id
      isPaying
      dataRetentionDays
      entitlements {
        ...AccountLimits
      }
      plan {
        ...CurrentAccountPlan
      }
      parentAccount {
        id
        name
      }
      parentAccountRelationship
    }
    currentUser {
      email
      fullName
      id
      isStaff
    }
  }
  ${AccountLimitsFragmentDoc}
  ${CurrentAccountPlanFragmentDoc}
`;

/**
 * __useAccountAndUserQuery__
 *
 * To run a query within a React component, call `useAccountAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountAndUserQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountAndUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    AccountAndUserQuery,
    AccountAndUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountAndUserQuery, AccountAndUserQueryVariables>(
    AccountAndUserDocument,
    options
  );
}
export function useAccountAndUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountAndUserQuery,
    AccountAndUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountAndUserQuery, AccountAndUserQueryVariables>(
    AccountAndUserDocument,
    options
  );
}
export type AccountAndUserQueryHookResult = ReturnType<
  typeof useAccountAndUserQuery
>;
export type AccountAndUserLazyQueryHookResult = ReturnType<
  typeof useAccountAndUserLazyQuery
>;
export type AccountAndUserQueryResult = Apollo.QueryResult<
  AccountAndUserQuery,
  AccountAndUserQueryVariables
>;
